import { onError } from '@apollo/client/link/error'
import { SnackbarProgrammatic as Snackbar } from 'buefy'

function fetchWrapper(frontendAppVersion, store) {
  function customFetch(uri, options) {
    const promise = fetch(uri, options)
    promise.then((response) => {
      const backendVersion = response.headers.get('x-app-version')
      if (backendVersion && backendVersion > frontendAppVersion) {
        store.commit('setPostponeUpdated')
      }
    })
    return promise
  }

  return customFetch
}

export default (app) => {
  const link = onError(
    ({ message, graphQLErrors, networkError, operation, forward }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach((err) => {
          // Handle Reddit API errors
          if (err.message.startsWith('REDDITAPI')) {
            Snackbar.open({
              message:
                'A Reddit error occurred. Reddit may be down right now. Check at redditstatus.com or wait a few minutes.',
              type: 'is-danger',
              duration: 8000,
              position: 'is-top-right'
            })
          }
        })
      } else if (
        networkError &&
        networkError.response &&
        networkError.response.status === 401
      ) {
        Snackbar.open({
          message:
            "To protect your account we need to double-check it's really you. Please log in again to continue.",
          type: 'is-warning',
          duration: 5000,
          position: 'is-top-right'
        })
        app.store.dispatch('logout')
        app.redirect({ path: '/login' })
      } else {
        // eslint-disable-next-line no-console
        console.log(
          '%cError',
          'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
          message
        )
      }
    }
  )

  return {
    link,

    httpEndpoint: app.$config.internalApiUrl + '/graphql',
    browserHttpEndpoint: app.$config.apiUrl + '/graphql',
    persisting: false,
    websocketsOnly: false,
    ssr: false,
    wsEndpoint: null,
    tokenName: null,

    httpLinkOptions: {
      credentials: 'include',
      fetch: fetchWrapper(app.$config.appVersion, app.store)
    },

    /*
     * For permanent authentication provide `getAuth` function.
     * The string returned will be used in all requests as authorization header
     */
    getAuth: (tokenName) => {
      // Auth is handled automatically by sending a session Cookie
      return ''
    }
  }
}
